/* Keep desktop mega-menu product links available to keyboard users too. */
document.querySelectorAll('header nav.navigation').forEach(nav=>{
 const desktop=()=>matchMedia('(min-width:1025px)').matches;
 const roots=[...nav.querySelectorAll('.level0.menu-parent')];
 const rootFor=target=>target instanceof Element?target.closest('.level0.menu-parent'):null;
 nav.addEventListener('focusin',event=>{
  if(!desktop())return;
  const root=rootFor(event.target);if(!root)return;
  roots.forEach(item=>item.classList.toggle('visible',item===root));
 });
 nav.addEventListener('focusout',event=>{
  if(!desktop())return;
  const root=rootFor(event.target);
  queueMicrotask(()=>{if(root&&!root.contains(document.activeElement))root.classList.remove('visible');});
 });
 nav.addEventListener('keydown',event=>{
  if(!desktop()||event.key!=='Escape')return;
  const root=rootFor(event.target);if(!root)return;
  event.preventDefault();event.stopPropagation();
  root.querySelector(':scope>menu-item>a')?.focus();
  root.classList.remove('visible');
 });
});
